import { FiAlertTriangle, FiXCircle, FiCheckCircle } from "react-icons/fi";

export default function ConfirmModal({
                                         open,
                                         title = "Confirmar acción",
                                         message = "¿Deseas continuar?",
                                         confirmText = "Confirmar",
                                         cancelText = "Cancelar",
                                         onConfirm,
                                         onClose,
                                         variant = "danger",
                                     }) {
    if (!open) return null;

    const confirmClass =
        variant === "danger" ? "btn-danger" : "btn-primary";

    return (
        <div className="modal-backdrop">
            <div className="modal-card" style={{ maxWidth: 480 }}>
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiAlertTriangle size={20} />
                        {title}
                    </h3>
                </div>

                <p style={{ marginBottom: 20, color: "#4b5563" }}>{message}</p>

                <div className="form-actions">
                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiXCircle size={16} />
                        {cancelText}
                    </button>

                    <button className={confirmClass} type="button" onClick={onConfirm}>
                        <FiCheckCircle size={16} />
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}